export default "__VITE_ASSET__DJwyaPt0__"